import React, { useState } from 'react';
import {
  Select,
  MenuItem,
  Typography,
  FormControl,
  InputLabel,
} from '@mui/material';
import useStore from 'src/store/cns';

const SelectToken: React.FC<{ onValueChange: (token: Token) => void }> = ({
  onValueChange,
}) => {
  const tokens = useStore(state => state.tokens);
  const [selectedTokenAddress, setSelectedTokenAddress] = useState<string>(
    tokens[0]?.tokenAddress || '',
  );

  const handleChange = (event: any) => {
    const newAddress = event.target.value;
    setSelectedTokenAddress(newAddress);

    const selectedToken = tokens.find(
      token => token.tokenAddress === newAddress,
    );
    if (selectedToken) {
      onValueChange(selectedToken);
    }
  };

  const formControlStyles = {
    '& .MuiOutlinedInput-root': {
      height: '46px',
      '&:hover fieldset': {
        borderColor: 'grey.600',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'grey.600',
      },
    },
    textAlign: 'start',
  };

  return (
    <FormControl fullWidth sx={formControlStyles}>
      <InputLabel id="payment-token-label">Payment Token</InputLabel>
      <Select
        labelId="payment-token-label"
        id="payment-token-select"
        data-cy="payment-token-select"
        value={selectedTokenAddress}
        onChange={handleChange}
        label="Payment Token"
      >
        {tokens.map(({ tokenAddress, name, symbol }) => (
          <MenuItem
            key={tokenAddress}
            value={tokenAddress}
            data-cy={`payment-token-option-${tokenAddress}`}
          >
            <Typography variant="body1" color="text.primary">
              {name} ({symbol})
            </Typography>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SelectToken;
